import { _js } from '@ifixit/localize';
import { faItalic } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const ItalicButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleItalic().run()}
         isActive={editor.isActive('italic')}
         isDisabled={!editor.can().toggleItalic()}
         icon={<FontAwesomeIcon icon={faItalic} />}
         title={_js('Italic')}
         shortcut={'i'}
      />
   );
};
